"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _SvgIcon = require("material-ui/SvgIcon");

var _SvgIcon2 = _interopRequireDefault(_SvgIcon);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RupeeIcon = function RupeeIcon(props) {
  return _react2.default.createElement(
    _SvgIcon2.default,
    props,
    _react2.default.createElement("path", { d: "m14.503919,4.798149l2.903959,0l1.114051,-1.671076l-10.910272,0l-1.114051,1.671076l1.893887,0c1.916168,0 3.691222,0.14854 4.396788,1.752774l-5.176623,0l-1.114051,1.671076l6.498631,0c0,0.007427 0,0.007427 0,0.007427c0,1.203175 -1.002646,3.045073 -4.300237,3.045073l-1.596806,0l0,1.559671l6.394652,7.991459l2.844543,0l-6.610036,-8.258831c2.725711,-0.14854 5.280602,-1.671076 5.644525,-4.344799l2.035,0l1.114051,-1.671076l-3.178759,0c-0.126259,-0.64615 -0.401058,-1.270018 -0.839252,-1.752774z" })
  );
};

exports.default = RupeeIcon;


//////////////////
// WEBPACK FOOTER
// ../lib/egov-ui-kit/custom-icons/rupee.js
// module id = ../lib/egov-ui-kit/custom-icons/rupee.js
// module chunks = 504